export const EXPORT_TOP_FLOP_SORT_KPI_PER_DATATABLE = {
    salesAmountDetail: {
        quantity: null
    },
    salesQuantityDetail: {
        amount: null
    },
    competitorVision: {
        amount: 'competitor_sales_amount',
        quantity: 'competitor_sales_quantity'
    },
    dynamicClient: {
        amount: 'cardholder_sales_amount_by_movement',
        quantity: 'cardholder_sales_quantity_by_movement'
    },
    customerSegmentationConsostyle: {
        amount: 'customer_segmentation_cardholder_sales_amount',
        quantity: 'customer_segmentation_cardholder_sales_quantity'
    },
    customerSegmentationLifestage: {
        amount: 'customer_segmentation_cardholder_sales_amount',
        quantity: 'customer_segmentation_cardholder_sales_quantity'
    }
};
//# sourceMappingURL=exportTopFlopSortKpiPerDatatable.constant.js.map